import type { Fetcher } from '@atlassian/post-office-placement-data/types';
import type { PlacementPreviewProviderProps } from '@atlassian/post-office-placement-preview-provider/types';
import {
	PlacementPreviewProvider as PlacementPreviewProviderRemote,
	createPreviewFetch as createPreviewFetchRemote,
} from '@atlassian/post-office-placement-preview-provider/preview-fetcher-provider';
import type { EligibleMessage } from '@post-office/message-template-contracts/shared-request-middleware-context/context-types';

export {
	PLACEMENT_REQUEST_URL,
	PREVIEW_REQUEST_URL,
	createReturnOverrideFetch,
} from '@atlassian/post-office-placement-preview-provider/preview-fetcher-provider';

export const PlacementPreviewProvider: ({
	returnOverride,
	eligibleMessages,
	children,
}: PlacementPreviewProviderProps<EligibleMessage>) => React.JSX.Element =
	PlacementPreviewProviderRemote<EligibleMessage>;

export const createPreviewFetch: ({
	eligibleMessages,
}: {
	eligibleMessages: EligibleMessage[];
}) => Fetcher['fetch'] = createPreviewFetchRemote<EligibleMessage>;
